import PayoutDetailsPage from "./payoutDetails";

export default PayoutDetailsPage;